import { combineReducers } from 'redux'
import {
  PRICECONSIGNEE_GET_LOADING,
  PRICECONSIGNEE_GET_ERROR,
  PRICECONSIGNEE_GET_SUCCESS,

  PRICECONSIGNEE_VIEW_ERROR,
  PRICECONSIGNEE_VIEW_LOADING,
  PRICECONSIGNEE_VIEW_SUCCESS,

  PRICECONSIGNEE_ADD_ERROR,
  PRICECONSIGNEE_ADD_LOADING,
  PRICECONSIGNEE_ADD_SUCCESS
} from '../actions/constant'

const priceconsigneeGetError = (state = false, action) => {
  switch (action.type) {
    case PRICECONSIGNEE_GET_ERROR:
      return action.priceconsigneeGetError
    default:
      return state
  }
}

const priceconsigneeGetLoading = (state = false, action) => {
  switch (action.type) {
    case PRICECONSIGNEE_GET_LOADING:
      return action.priceconsigneeGetLoading
    default:
      return state
  }
}

const priceconsigneeGetSuccess = (state = false, action) => {
  switch (action.type) {
    case PRICECONSIGNEE_GET_SUCCESS:
      return action.priceconsigneeGetSuccess
    default:
      return state
  }
}

const priceconsignees = (state = [], action) => {
  switch (action.type) {
    case PRICECONSIGNEE_GET_SUCCESS:
      return action.priceconsignees
    default:
      return state
  }
}

const priceconsigneeViewLoading = (state = false, action) => {
  switch (action.type) {
    case PRICECONSIGNEE_VIEW_LOADING:
      return action.priceconsigneeViewLoading
    default:
      return state
  }
}

const priceconsigneeViewError = (state = false, action) => {
  switch (action.type) {
    case PRICECONSIGNEE_VIEW_ERROR:
      return action.priceconsigneeViewError
    default:
      return state
  }
}

const priceconsigneeViewSuccess = (state = false, action) => {
  switch (action.type) {
    case PRICECONSIGNEE_VIEW_SUCCESS:
      return action.priceconsigneeViewSuccess
    default:
      return state
  }
}

const priceconsignee = (state=[], action) => {
  switch (action.type) {
    case PRICECONSIGNEE_VIEW_SUCCESS:
      return action.priceconsignee
    default:
      return state
  }
}

const priceconsigneeAdded = (state=[], action) => {
  switch (action.type) {
    case PRICECONSIGNEE_ADD_SUCCESS:
      return action.priceconsigneeAdded
    default:
      return state
  }
}

const priceconsigneeAddError = (state = false, action) => {
  switch (action.type) {
    case PRICECONSIGNEE_ADD_ERROR:
      return action.priceconsigneeAddError
    default:
      return state
  }
}

const priceconsigneeAddLoading = (state = false, action) => {
  switch (action.type) {
    case PRICECONSIGNEE_ADD_LOADING:
      return action.priceconsigneeAddLoading
    default:
      return state
  }
}

const priceconsigneeAddSuccess = (state = false, action) => {
  switch (action.type) {
    case PRICECONSIGNEE_ADD_SUCCESS:
      return action.priceconsigneeAddSuccess
    default:
      return state
  }
}

const priceconsigneeReducer = combineReducers({
  priceconsigneeGetError,
  priceconsigneeGetLoading,
  priceconsigneeGetSuccess,
  priceconsignees,

  priceconsigneeViewLoading,
  priceconsigneeViewError,
  priceconsigneeViewSuccess,
  priceconsignee,

  priceconsigneeAddError,
  priceconsigneeAddLoading,
  priceconsigneeAddSuccess,
  priceconsigneeAdded
})

export default priceconsigneeReducer
